<template>
  <div :class="`${arabic?'arFont':'enFont'}`">
    <v-text-field
      :label="i18n[field.label]"
      outlined
      v-if="field.type == 'text'"
      autocomplete="disabled"
      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
      dense
      :readonly="field.readonly"
      :disabled="field.readonly"
      :class="`${arabic?'arFont':'enFont'}`"
      v-model="item[field.name]"
    >
      <template v-slot:append-outer v-if="field.info && field.info[language]">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
          </template>
          <span :class="`${arabic?'arFont':'enFont'} pa-0`">
            {{field.info.en}}
          </span>
        </v-tooltip>
      </template>
    </v-text-field>
    <v-autocomplete
      :items="field.data"
      v-model="item[field.name]"
      :label="i18n[field.label]"
      clearable
      :multiple="field.multiple"
      autocomplete="disabled"
      :rules="[ field.required ? rules.required : false ]"
      v-if="field.type == 'select'"
      :readonly="field.readonly"
      :disabled="field.readonly"
      outlined
      dense
      :return-object="field.returnObject"
      :item-value="`${field.returnValue? field.returnValue : field.name + '_id'}`"
      :class="`${arabic?'arFont':'enFont'}`"
    >
      <template v-slot:append-outer v-if="field.info && field.info[language]">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
          </template>
          <span :class="`${arabic?'arFont':'enFont'} pa-0`">
            {{field.info.en}}
          </span>
        </v-tooltip>
      </template>
    </v-autocomplete>
    <v-switch 
      v-if="field.type == 'switch'"
      :class="`${arabic?'arFont':'enFont'} mt-0`" 
      :label="i18n[field.label]" 
      :readonly="field.readonly"
      :disabled="field.readonly"
      color="primary"
      dense
      inset
      style="transform:scale(0.8)"
      :hint="`${field.info && field.info[language] ? field.info.en : ''}`"
      :persistent-hint="field.info && field.info[language] ? true : false"
      v-model="item[field.name]"
    >
    </v-switch>
    <v-textarea
      :label="i18n[field.label]"
      outlined
      :readonly="field.readonly"
      :disabled="field.readonly"
      v-if="field.type == 'textarea'"
      autocomplete="disabled"
      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
      dense
      :class="`${arabic?'arFont':'enFont'}`"
      v-model="item[field.name]"
    >
      <template v-slot:append-outer v-if="field.info && field.info[language]">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
          </template>
          <span :class="`${arabic?'arFont':'enFont'} pa-0`">
            {{field.info.en}}
          </span>
        </v-tooltip>
      </template>
    </v-textarea>
    <v-text-field
      :label="i18n[field.label]"
      :readonly="field.readonly"
      :disabled="field.readonly"
      outlined
      v-if="field.type == 'number'"
      autocomplete="disabled"
      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
      dense
      @keypress="isNumber($event)"
      :class="`${arabic?'arFont':'enFont'}`"
      v-model="item[field.name]"
    >
      <template v-slot:append-outer v-if="field.info && field.info[language]">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
          </template>
          <span :class="`${arabic?'arFont':'enFont'} pa-0`">
            {{field.info.en}}
          </span>
        </v-tooltip>
      </template>
    </v-text-field>
    <v-menu
      v-model="datepicker[field.name]"
      :close-on-content-click="false"
      v-if="field.type == 'date'"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :label="i18n[field.label]"
          outlined
          :disabled="field.readonly"
          v-if="field.type == 'date'"
          autocomplete="disabled"
          :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
          dense
          :class="`${arabic?'arFont':'enFont'}`"
          v-model="item[field.name]"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="item[field.name]"
        @input="datepicker[field.name] = false"
      ></v-date-picker>
    </v-menu>
    <div v-if="field.type == 'editor'">{{i18n[field.label]}}</div>
    <vue-editor ref="editorV" v-if="field.type == 'editor'" v-model="item[field.name]"></vue-editor>
    <v-text-field
      :label="i18n[field.label]"
      :readonly="true"
      v-if="field.type == 'upload'"
      autocomplete="disabled"
      :class="`${arabic?'arFont':'enFont'}`"
      dense
      outlined
      :loading="uploadProgress"
      @click="pickFileImages(field.name)"
      v-model.trim="item[field.name]"
      :rules="[rules.required]"
    >
      <template v-slot:append-outer v-if="field.info && field.info[language]">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
          </template>
          <span :class="`${arabic?'arFont':'enFont'} pa-0`">
            {{field.info.en}}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:prepend>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small color="primary" :loading="uploadProgress" icon @click="pickFileImages(field.name)" v-on="on">
              <v-icon>
                cloud
              </v-icon>
            </v-btn>
          </template>
          {{field.info.en}}
          <input
            type="file"
            style="display: none"
            ref="fileImages"
            accept="csv/*"
            @change="onFilePickedImages"
            v-if="field.type == 'upload'"
          >
        </v-tooltip>
      </template>
    </v-text-field>
    
  </div>
</template>
<script>
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { firebase, store, db, auth, storageRef } from '@/fb';
export default {
  props:['field', 'item', 'index'],
  data() {
    return {
      uploadProgress:null,
      uploadFiled:null,
      file:null,
      datepicker:{},
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
    }
  },
  methods: {
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    pickFileImages(name){
      this.uploadFiled = name
      this.$refs.fileImages.click()
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      // const allowedExtensions = []
      // if(!allowedExtensions.includes(ext)) {

      //   return
      // }
      var uploadTask = storageRef.child('images/J_B_E_' + randomString(16, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = true
          }, (error) =>{
          //  console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
					this.uploadProgress = false
          this.$emit('getUpload', {field:this.uploadFiled, value:downloadURL, index:this.$props.index} )
          // console.log(downloadURL)
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } 
    },
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
}
</script>
